import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const CartIcon = ({ count }: { count: number }) => (
  <div style={{ position: "relative", display: "inline-block" }}>
    <ShoppingCartIcon sx={{ fontSize: 40, color: "#ffffff" }} />
    {count > 0 && (
      <span
        style={{
          position: "absolute",
          top: "-8px",
          right: "-8px",
          background: "green",
          color: "black",
          borderRadius: "50%",
          padding: "4px 8px",
          fontSize: "20px",
          fontWeight: "bold"
        }}
      >
        {count}
      </span>
    )}
  </div>
);

export default CartIcon;